// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"234":"f6c44dd39dcb3a98","6273":"d054ac0e22c39947"}[chunkId] + ".css";
};